import { Block, Flex, Typography } from '@aloft/toolkit-sui';

import { getSectionTitle } from './getSectionTitle.js';
import { SectionID } from './types.js';

type Props = React.PropsWithChildren<{
  sectionID: SectionID;
  activeSectionID: SectionID;
}>;

export function Section({ sectionID, activeSectionID, children }: Props) {
  if (sectionID !== activeSectionID) return null;
  return (
    <Flex flexDirection="column" gap="16px">
      <Typography variant="h3">{getSectionTitle(sectionID)}</Typography>
      <Block backgroundColor="strokeDefault" height="1px" />
      <Flex flexDirection="column" gap="8px">
        {children}
      </Flex>
    </Flex>
  );
}
